import { FanforgeGameCard } from '../components/fanforge-game-card';
import { useVisibleGameIds } from '../hooks/use-visible-game-ids';
import { CommunityBadge } from '../components/community-badge';
import { SimplifiedFtue } from '../components/simplified-ftue';
import { useEffect, useState } from 'react';
import { useFTUESeen } from '@hotpot-arcade/ui-components';

export const FanforgeHome = () => {
  const visibleGameIds = useVisibleGameIds();

  const { seen, markSeen, ready } = useFTUESeen('simplified-ftue-seen');
  const [showFtue, setShowFtue] = useState(false);
  useEffect(() => {
    if (ready && !seen) setShowFtue(true);
  }, [ready, seen]);

  return (
    <div className="flex flex-col p-3 bg-gray-gradient-1 h-full">
      {showFtue && (
        <SimplifiedFtue
          onClose={() => {
            markSeen();
            setShowFtue(false);
          }}
        />
      )}
      <div className="relative flex flex-row justify-between items-center pb-3 border-b-[0.5px] border-b-[#2D2D31]">
        <CommunityBadge />
        <img
          src="images/fanforge-logo.svg"
          alt="Fanforge Logo"
          className="md:absolute md:left-1/2 md:-translate-x-1/2"
        />
      </div>
      <div className="flex flex-col py-2 mt-1 gap-3 overflow-y-auto">
        <h2 className="text-white font-bold text-lg">Game Library</h2>
        <div className="grid gap-2 grid-cols-2 md:grid-cols-4">
          {visibleGameIds.map((id) => (
            <FanforgeGameCard key={id} gameId={id} />
          ))}
        </div>
        <p className="text-center text-xs text-white">Check Back Soon for New Games!</p>
      </div>
    </div>
  );
};
